module.exports = __webpack_public_path__ + "static/media/city.d8632c8f.svg";